import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { confirmRequest } from '../../services/api/offline-consult';
import { toast } from 'react-toastify';

const OfflineModalClaimAndConfirm = ({ visible, closeModal, onClaim, submitModal, slotDetailsForClaimandConfirm, onComplete }) => {
    console.log('Slot Details for Claim and Confirm:', slotDetailsForClaimandConfirm); 
    console.log('Submit Modal:', submitModal);  

    const handleSubmit = () => {
        if (slotDetailsForClaimandConfirm) {
          const { requestId,dateKey, slot, slotType, timeRange } = slotDetailsForClaimandConfirm;
          // slotTimeRange should be timeRange (or null)
          confirmRequest(
            requestId, // requestId
            dateKey,               // dateKey
            slot,                  // slot
            null,                  // centerRequest (pass null if not available)
            slotType,              // slotType
            timeRange,             // slotTimeRange (can be null)
            true,                  // shiftAndConfirm (set as needed)
            false,
            true                  // selfBook (set as needed)
          ).then((response) => {
            if (response.error) {
              console.error('Error confirming request:', response.errorMessage);
              toast.error(`Error: ${response.errorMessage}`);
            } else {
              toast.success('Request confirmed successfully!');
              closeModal();
              onComplete()
            }
          });
        } else {
          alert('Slot details are missing. Please try again.');
        }
      }
    return (
        <Modal isOpen={visible} toggle={closeModal}>
            <ModalHeader toggle={closeModal}>Claim and Confirm</ModalHeader>
            <ModalBody>
                Are you sure you want to claim and confirm the request?
            </ModalBody>
            <ModalFooter>
                <Button color="success" onClick={handleSubmit}>
                  Claim And Confirm Request
                </Button>
                <Button color="secondary" onClick={closeModal}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default OfflineModalClaimAndConfirm;
